import { createSelector } from 'reselect'
import { getCurrentLoyaltyMemberTier } from 'selectors/loyaltySelectors'
import { getLuxuryPlusSubscriptionItems } from './view/luxuryPlusSubscription'

export const getCheckoutLoyaltyTier = createSelector(
  getCurrentLoyaltyMemberTier,
  getLuxuryPlusSubscriptionItems,
  (currentTier, subscriptionItems) => {
    const itemTier = subscriptionItems[0]?.tier
    return itemTier ?? currentTier
  },
)
